import { AnyAction } from '@reduxjs/toolkit';
import { GetApplicationRolesRoutine } from '~modules/Auth/redux-routines';
import { IApplicationRolesState } from '../interfaces';

export const initialState: IApplicationRolesState = {
  data: [],
  error: null,
  isFetching: false,
};

export const applicationRolesReducer = (
  state: IApplicationRolesState = initialState,
  action: AnyAction,
): IApplicationRolesState => {
  switch (action.type) {
    case GetApplicationRolesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GetApplicationRolesRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetApplicationRolesRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
